import React, { FC, useCallback, useRef, useState } from 'react';
import { ButtonGroup, Checkbox, ClickAwayListener, Grow, IconButton, List, ListItem, ListItemIcon, Paper, Popper } from '@material-ui/core';
import { useStyles } from './styles';
import { HamburgerIcon } from '../../../../components';

interface Props {
  translation: any;
  selectedCheckboxes: string[];
  onChange: (selected: string[]) => void;
}

export const FilterButton: FC<Props> = ({ translation, selectedCheckboxes, onChange }) => {
  const classes = useStyles();
  const anchorRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [selected, setSelected] = useState<string[]>(selectedCheckboxes);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    onChange(selected);
    setOpen(false);
  };

  const handleCheckboxSelection = useCallback(
    (checkbox: string) => {
      const changed = selected.includes(checkbox) ? selected.filter((c) => c !== checkbox) : [...selected, checkbox];
      setSelected(changed);
    },
    [selected],
  );

  return (
    <>
      <ButtonGroup variant="contained" ref={anchorRef} style={{ boxShadow: 'none' }}>
        <IconButton aria-expanded={open ? 'true' : undefined} onClick={handleToggle}>
          <HamburgerIcon />
        </IconButton>
      </ButtonGroup>
      <Popper open={open} anchorEl={anchorRef.current} transition disablePortal style={{ zIndex: 6000 }}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper className={classes.popupPaper}>
              <ClickAwayListener onClickAway={handleClose}>
                <List>
                  <ListItem key="prime" role={undefined} dense>
                    <ListItemIcon className={classes.checkbox}>
                      <Checkbox edge="start" checked={selected.includes('prime')} onChange={() => handleCheckboxSelection('prime')} />
                    </ListItemIcon>
                    <span className={`${classes.legendListIcon} ${classes.legendPrime}`} />
                    {translation.prime_partnership}
                  </ListItem>
                  <ListItem key="master" role={undefined} dense>
                    <ListItemIcon className={classes.checkbox}>
                      <Checkbox edge="start" checked={selected.includes('master')} onChange={() => handleCheckboxSelection('master')} />
                    </ListItemIcon>
                    <span className={`${classes.legendListIcon} ${classes.legendMasterIb}`} />
                    {translation.master_partnership}
                  </ListItem>
                  <ListItem key="ib" role={undefined} dense>
                    <ListItemIcon className={classes.checkbox}>
                      <Checkbox edge="start" checked={selected.includes('ib')} onChange={() => handleCheckboxSelection('ib')} />
                    </ListItemIcon>
                    <span className={`${classes.legendListIcon} ${classes.legendIb}`} />
                    {translation.ib_partnership}
                  </ListItem>
                  <ListItem key="subIb" role={undefined} dense>
                    <ListItemIcon className={classes.checkbox}>
                      <Checkbox edge="start" checked={selected.includes('subIb')} onChange={() => handleCheckboxSelection('subIb')} />
                    </ListItemIcon>
                    <span className={`${classes.legendListIcon} ${classes.legendSubIb}`} />
                    {translation.sub_id_partnership}
                  </ListItem>
                  <ListItem key="mlm" role={undefined} dense>
                    <ListItemIcon className={classes.checkbox}>
                      <Checkbox edge="start" checked={selected.includes('mlm')} onChange={() => handleCheckboxSelection('mlm')} />
                    </ListItemIcon>
                    <span className={`${classes.legendListIcon} ${classes.legendMlm}`} />
                    {translation.mlm_partnership}
                  </ListItem>
                  <ListItem key="terminated" role={undefined} dense>
                    <ListItemIcon className={classes.checkbox}>
                      <Checkbox edge="start" checked={selected.includes('terminated')} onChange={() => handleCheckboxSelection('terminated')} />
                    </ListItemIcon>
                    <span className={`${classes.legendListIcon} ${classes.legendTerminated}`} />
                    <span style={{ display: 'inline-flex' }}>{translation.terminated_partnerships}</span>
                  </ListItem>
                </List>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};
